import React, { useState, useEffect } from "react";
import defaultPicture from "../assets/default_pfp.png";
import { Link, Route, useParams, useNavigate } from "react-router-dom";
import PostingList from "./PostingList";
import styles from "./ProfilePublic.module.css";
import Header from './Header.jsx';
import ProfileInfo from "./ProfileInfo.jsx";
import CensorProfanity from './ProfanityCensor';
import ProfileRanks from "./ProfileRanks.jsx";
import translations from './translation.js';

const ProfilePublic = ({ appRefresh }) => {
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

  const { userID } = useParams();
  const [username, setUsername] = useState("");
  const [exp, setExp] = useState("");
  const [discord, setDiscord] = useState(null); // Initialize as null
  const [picture, setProfilePic] = useState(defaultPicture);
  const [followingCount, setFollowing] = useState([]);
  const [followerCount, setFollower] = useState([]);
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [priv,setPrivate] = useState(false);
  const navigate = useNavigate();
  const [connectionID, setConID] = useState(null);
  const [ranks, setRanks] = useState({});

  // get posts from user (excluding comments, dms, and group messages)
  const loadPosts = () => {
    if (sessionStorage.getItem("token")) {
      fetch(`${process.env.REACT_APP_API_PATH}/posts?authorID=${userID}&recipientUserID=&parentID=`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => res.json())
        .then((result) => {
          if (result) {
            const filteredPosts = result[0].filter(post => !post.attributes.hidden);
            setIsLoaded(true);
            setPosts(filteredPosts);
            // console.log(filteredPosts);
          }
        })
        .catch((err) => {
          setIsLoaded(true);
          setError(err);
          console.log("ERROR loading posts");
        });
    }
  };
  const load_in_posts = () => {
    console.log(priv);
    if (!priv) {
      return(
      <div className={styles.postsContainerStyle}>
        <PostingList
          refresh={appRefresh}
          posts={posts.map(post => ({
            ...post,
            content: <CensorProfanity text={post.content} />
          }))}            
          error={error}
          isLoaded={isLoaded}
          type="postlist"
          loadPosts={loadPosts}
        />
      </div>
      );
    } 
    else {
      return(
      <div className={styles.postsContainerStyle}>
        <h3>{translations[currentLanguage].no_post}</h3>
      </div>);
    };
  };

  const isOwn = () => {
    if (sessionStorage.getItem("token")) {
      if (sessionStorage.getItem("user") == userID) {
        return true;
      }
    }
    return false;
  };

  const loadFollowers = () => {
    fetch(
      `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        }
      })
      .then((res) => res.json())
      .then((data) => { 
        const allowedConnections = [1, 4, -4, 5];
        let count = 0;
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
          if (data[0][i].attributes.connection && allowedConnections.includes(data[0][i].attributes.connection)) {
            count += 1
          }
        }
        setFollower(count)
      })
      .catch((err) => {
        console.log(err);
      }
      );
  };

  const loadFollowing = () => {
    fetch(
      `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        }
      })
      .then((res) => res.json())
      .then((data) => { 
        let count = 0;
        const allowedConnections = [-1, 4, -4, -5];
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
          if (data[0][i].attributes.connection && allowedConnections.includes(data[0][i].attributes.connection)) {
            count += 1
          }
        }
        setFollowing(count)
       })
      .catch((err) => {
        console.log(err);
      }
      );
  };


  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      // get name/email
      fetch(
        `${process.env.REACT_APP_API_PATH}/users/${userID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        })
        .then((res) => res.json())
        .then((data) => {
          setUsername(data.attributes.username);
          setExp(data.attributes.exp);
          if (data.attributes.picture != "") { setProfilePic(data.attributes.picture) }
          if (data.attributes.discord?.discordLink) { setDiscord(data.attributes.discord.discordLink);}
          if (data.attributes.ranks) {
            setRanks(data.attributes.ranks)
          }
          setPrivate(data.attributes.MakePrivate);

        })
        .catch((err) => {
          console.log(err);
        }
        );

        // get name/email
      fetch(
        `${process.env.REACT_APP_API_PATH}/users/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        })
        .then((res) => res.json())
        .then((data) => {
          console.log("done") }
        )
        .catch((err) => {
          console.log(err);
        }
        );

      loadFollowers();
      loadFollowing();
      loadPosts();
    }
  }, [userID, followerCount, followingCount]);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      navigate("/login");
    }
  }, []);

  return (
    <div className={styles.wrapperStyle}>
      <Header />
      <div className={styles.content}>
        <ProfileInfo
          isOwn={isOwn()}
          picture={picture}
          username={username}
          exp={exp}
          discord={discord !== null ? discord : translations[currentLanguage].none} // Display "None" if discord is null
          followers={followerCount}
          following={followingCount}
        />

        <h3 className={styles.h3style}>{translations[currentLanguage].ranks}</h3>
        <ProfileRanks ranks={ranks} style='profile'/>
        <h3 className={styles.h3style}>{translations[currentLanguage].posts}</h3>
        <div className={styles.postsContainerStyle}>
        <PostingList
          refresh={appRefresh}
          posts={posts.map(post => ({
            ...post,
            content: <CensorProfanity text={post.content} />
          }))}            
          error={error}
          isLoaded={isLoaded}
          type="postlist"
          loadPosts={loadPosts}
        />
      </div>
      </div>
    </div>
  );
}

export default ProfilePublic;
